export function convertInputsToKeyValuePair(object) {
  const payload = {}
  object.map(row => row.singleRow.rowInputs).flat().forEach(input => {
    payload[input.key] = input.value
  })

  return payload
}
